package com.narbase.letsgo.web.models

import com.narbase.letsgo.dto.EnumDtoName

enum class DriverGroupPurpose(dtoName: String? = null) : EnumDtoName {
    TARGET("Target"),
    HIDE_PASSENGER_PHONE("Hide Passenger Phone")
    ;

    override val dtoName = dtoName ?: this.name
}